var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import useSharedDataContext from '~/contexts/shared-data';
import sfApiFetch from '~/models/sfapi';
import { camelCaseKeys } from '~/helpers/page-data-utils';
const INITIAL_STATE = {
    user: {
        contact: {},
        opportunities: [],
        schools: [],
        subscriptions: []
    }
};
function fetchUser() {
    return __awaiter(this, void 0, void 0, function* () {
        const user = yield sfApiFetch('users');
        return camelCaseKeys(Object.assign(Object.assign({}, INITIAL_STATE), user));
    });
}
export default function useMyOpenStaxUser(isVerified, fetchTime) {
    const [user, setUser] = React.useState({ error: 'not loaded' });
    const { flags } = useSharedDataContext();
    React.useEffect(() => {
        const isEnabled = flags && flags.my_openstax;
        if (isEnabled) {
            if (isVerified) {
                fetchUser().then(setUser);
            }
            else {
                setUser({ error: 'Not faculty verified' });
            }
        }
    }, [flags, isVerified, fetchTime]);
    return user;
}
